import viphalfscreen from './src/viphalfscreen.vue'

viphalfscreen.install = function (Vue) {
    Vue.component(viphalfscreen.name, viphalfscreen)
}

// https://cdflove9426.github.io/vue/vue_mark_scroll.html#position-fixed
// 更多区域显示中滚动区域需要设置
window.ModalHelper = (function(bodyCls) {
    
        var scrollTop;
        var evenode;
        return {
            afterOpen: function() {
                // try {
                //     scrollTop = document.scrollingElement?document.scrollingElement.scrollTop:0;
                //     document.body.classList.add(bodyCls);
                //     document.body.style.top = -scrollTop + 'px';
                // } catch(error) {}
            },
            beforeClose: function() {
                // try {
                //     document.body.classList.remove(bodyCls);
                //     // scrollTop lost after set position:fixed, restore it back.
                //     document.scrollingElement && (document.scrollingElement.scrollTop = scrollTop);
                // } catch(error) {}
            }
        };
})('modal-open');

export default viphalfscreen



// WEBPACK FOOTER //
// ./node_modules/@kkmh/pays/src/components/viphalfscreen/index.js